/** @jsxImportSource @emotion/react */
import React from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import Routing from '../Routing';
import { AppProvider } from '../context/ContextProvider';
import { MgmtProvider } from '../context/MgmtFeeContext';
import { ThemeProvider } from '../context/ThemeContext';
import { useFinalizeOnPaymentRedirect } from '../views/Accounts/hooks/useFinalizeOnPaymentRedirect';

const App = () => {
  // checkout.com Full Flow: finalize the payment session when Flow redirects back (e.g. after 3DS).
  // No-op unless the `flowPaymentsEnabled` flag is on. Runs at app root so it catches the redirect
  // regardless of which page the browser lands on.
  useFinalizeOnPaymentRedirect();

  return (
    <ThemeProvider>
      <AppProvider>
        <MgmtProvider>
          <div
            className="w-full h-[100dvh] bg-white dark:bg-slate-900 transition-colors overflow-hidden"
            data-testid="app-container"
          >
            <Routing />
          </div>
        </MgmtProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID || '',
  options: {
    bootstrap: 'localStorage',
  },
})(App);
